import { ImgID } from "../image_loader/img_id.js";

export function getFlagByCountryCode( country_code: string ): ImgID {
  if ( !country_code ) return ImgID.Flag_unknown;
  const upper_code = country_code.toUpperCase();

  switch ( upper_code ) {
    case 'AD': return ImgID.Flag_AD;
    case 'AE': return ImgID.Flag_AE;
    case 'AF': return ImgID.Flag_AF;
    case 'AG': return ImgID.Flag_AG;
    case 'AI': return ImgID.Flag_AI;
    case 'AL': return ImgID.Flag_AL;
    case 'AM': return ImgID.Flag_AM;
    case 'AN': return ImgID.Flag_AN;
    case 'AO': return ImgID.Flag_AO;
    case 'AQ': return ImgID.Flag_AQ;
    case 'AR': return ImgID.Flag_AR;
    case 'AS': return ImgID.Flag_AS;
    case 'AT': return ImgID.Flag_AT;
    case 'AU': return ImgID.Flag_AU;
    case 'AW': return ImgID.Flag_AW;
    case 'AX': return ImgID.Flag_AX;
    case 'AZ': return ImgID.Flag_AZ;
    case 'BA': return ImgID.Flag_BA;
    case 'BB': return ImgID.Flag_BB;
    case 'BD': return ImgID.Flag_BD;
    case 'BE': return ImgID.Flag_BE;
    case 'BF': return ImgID.Flag_BF;
    case 'BG': return ImgID.Flag_BG;
    case 'BH': return ImgID.Flag_BH;
    case 'BI': return ImgID.Flag_BI;
    case 'BJ': return ImgID.Flag_BJ;
    case 'BL': return ImgID.Flag_BL;
    case 'BM': return ImgID.Flag_BM;
    case 'BN': return ImgID.Flag_BN;
    case 'BO': return ImgID.Flag_BO;
    case 'BR': return ImgID.Flag_BR;
    case 'BS': return ImgID.Flag_BS;
    case 'BT': return ImgID.Flag_BT;
    case 'BW': return ImgID.Flag_BW;
    case 'BY': return ImgID.Flag_BY;
    case 'BZ': return ImgID.Flag_BZ;
    case 'CA': return ImgID.Flag_CA;
    case 'CC': return ImgID.Flag_CC;
    case 'CD': return ImgID.Flag_CD;
    case 'CF': return ImgID.Flag_CF;
    case 'CG': return ImgID.Flag_CG;
    case 'CH': return ImgID.Flag_CH;
    case 'CI': return ImgID.Flag_CI;
    case 'CK': return ImgID.Flag_CK;
    case 'CL': return ImgID.Flag_CL;
    case 'CM': return ImgID.Flag_CM;
    case 'CN': return ImgID.Flag_CN;
    case 'CO': return ImgID.Flag_CO;
    case 'CR': return ImgID.Flag_CR;
    case 'CU': return ImgID.Flag_CU;
    case 'CV': return ImgID.Flag_CV;
    case 'CW': return ImgID.Flag_CW;
    case 'CX': return ImgID.Flag_CX;
    case 'CY': return ImgID.Flag_CY;
    case 'CZ': return ImgID.Flag_CZ;
    case 'DE': return ImgID.Flag_DE;
    case 'DJ': return ImgID.Flag_DJ;
    case 'DK': return ImgID.Flag_DK;
    case 'DM': return ImgID.Flag_DM;
    case 'DO': return ImgID.Flag_DO;
    case 'DZ': return ImgID.Flag_DZ;
    case 'EC': return ImgID.Flag_EC;
    case 'EE': return ImgID.Flag_EE;
    case 'EG': return ImgID.Flag_EG;
    case 'EH': return ImgID.Flag_EH;
    case 'ER': return ImgID.Flag_ER;
    case 'ES': return ImgID.Flag_ES;
    case 'ET': return ImgID.Flag_ET;
    case 'EU': return ImgID.Flag_EU;
    case 'FI': return ImgID.Flag_FI;
    case 'FJ': return ImgID.Flag_FJ;
    case 'FK': return ImgID.Flag_FK;
    case 'FM': return ImgID.Flag_FM;
    case 'FO': return ImgID.Flag_FO;
    case 'FR': return ImgID.Flag_FR;
    case 'GA': return ImgID.Flag_GA;
    case 'GB': return ImgID.Flag_GB;
    case 'GD': return ImgID.Flag_GD;
    case 'GE': return ImgID.Flag_GE;
    case 'GG': return ImgID.Flag_GG;
    case 'GH': return ImgID.Flag_GH;
    case 'GI': return ImgID.Flag_GI;
    case 'GL': return ImgID.Flag_GL;
    case 'GM': return ImgID.Flag_GM;
    case 'GN': return ImgID.Flag_GN;
    case 'GQ': return ImgID.Flag_GQ;
    case 'GR': return ImgID.Flag_GR;
    case 'GS': return ImgID.Flag_GS;
    case 'GT': return ImgID.Flag_GT;
    case 'GU': return ImgID.Flag_GU;
    case 'GW': return ImgID.Flag_GW;
    case 'GY': return ImgID.Flag_GY;
    case 'HK': return ImgID.Flag_HK;
    case 'HN': return ImgID.Flag_HN;
    case 'HR': return ImgID.Flag_HR;
    case 'HT': return ImgID.Flag_HT;
    case 'HU': return ImgID.Flag_HU;
    case 'IC': return ImgID.Flag_IC;
    case 'ID': return ImgID.Flag_ID;
    case 'IE': return ImgID.Flag_IE;
    case 'IL': return ImgID.Flag_IL;
    case 'IM': return ImgID.Flag_IM;
    case 'IN': return ImgID.Flag_IN;
    case 'IQ': return ImgID.Flag_IQ;
    case 'IR': return ImgID.Flag_IR;
    case 'IS': return ImgID.Flag_IS;
    case 'IT': return ImgID.Flag_IT;
    case 'JE': return ImgID.Flag_JE;
    case 'JM': return ImgID.Flag_JM;
    case 'JO': return ImgID.Flag_JO;
    case 'JP': return ImgID.Flag_JP;
    case 'KE': return ImgID.Flag_KE;
    case 'KG': return ImgID.Flag_KG;
    case 'KH': return ImgID.Flag_KH;
    case 'KI': return ImgID.Flag_KI;
    case 'KM': return ImgID.Flag_KM;
    case 'KN': return ImgID.Flag_KN;
    case 'KP': return ImgID.Flag_KP;
    case 'KR': return ImgID.Flag_KR;
    case 'KW': return ImgID.Flag_KW;
    case 'KY': return ImgID.Flag_KY;
    case 'KZ': return ImgID.Flag_KZ;
    case 'LA': return ImgID.Flag_LA;
    case 'LB': return ImgID.Flag_LB;
    case 'LC': return ImgID.Flag_LC;
    case 'LI': return ImgID.Flag_LI;
    case 'LK': return ImgID.Flag_LK;
    case 'LR': return ImgID.Flag_LR;
    case 'LS': return ImgID.Flag_LS;
    case 'LT': return ImgID.Flag_LT;
    case 'LU': return ImgID.Flag_LU;
    case 'LV': return ImgID.Flag_LV;
    case 'LY': return ImgID.Flag_LY;
    case 'MA': return ImgID.Flag_MA;
    case 'MC': return ImgID.Flag_MC;
    case 'MD': return ImgID.Flag_MD;
    case 'ME': return ImgID.Flag_ME;
    case 'MF': return ImgID.Flag_MF;
    case 'MG': return ImgID.Flag_MG;
    case 'MH': return ImgID.Flag_MH;
    case 'MK': return ImgID.Flag_MK;
    case 'ML': return ImgID.Flag_ML;
    case 'MM': return ImgID.Flag_MM;
    case 'MN': return ImgID.Flag_MN;
    case 'MO': return ImgID.Flag_MO;
    case 'MP': return ImgID.Flag_MP;
    case 'MQ': return ImgID.Flag_MQ;
    case 'MR': return ImgID.Flag_MR;
    case 'MS': return ImgID.Flag_MS;
    case 'MT': return ImgID.Flag_MT;
    case 'MU': return ImgID.Flag_MU;
    case 'MV': return ImgID.Flag_MV;
    case 'MW': return ImgID.Flag_MW;
    case 'MX': return ImgID.Flag_MX;
    case 'MY': return ImgID.Flag_MY;
    case 'MZ': return ImgID.Flag_MZ;
    case 'NA': return ImgID.Flag_NA;
    case 'NC': return ImgID.Flag_NC;
    case 'NE': return ImgID.Flag_NE;
    case 'NF': return ImgID.Flag_NF;
    case 'NG': return ImgID.Flag_NG;
    case 'NI': return ImgID.Flag_NI;
    case 'NL': return ImgID.Flag_NL;
    case 'NO': return ImgID.Flag_NO;
    case 'NP': return ImgID.Flag_NP;
    case 'NR': return ImgID.Flag_NR;
    case 'NU': return ImgID.Flag_NU;
    case 'NZ': return ImgID.Flag_NZ;
    case 'OM': return ImgID.Flag_OM;
    case 'PA': return ImgID.Flag_PA;
    case 'PE': return ImgID.Flag_PE;
    case 'PF': return ImgID.Flag_PF;
    case 'PG': return ImgID.Flag_PG;
    case 'PH': return ImgID.Flag_PH;
    case 'PK': return ImgID.Flag_PK;
    case 'PL': return ImgID.Flag_PL;
    case 'PN': return ImgID.Flag_PN;
    case 'PR': return ImgID.Flag_PR;
    case 'PS': return ImgID.Flag_PS;
    case 'PT': return ImgID.Flag_PT;
    case 'PW': return ImgID.Flag_PW;
    case 'PY': return ImgID.Flag_PY;
    case 'QA': return ImgID.Flag_QA;
    case 'RO': return ImgID.Flag_RO;
    case 'RS': return ImgID.Flag_RS;
    case 'RU': return ImgID.Flag_RU;
    case 'RW': return ImgID.Flag_RW;
    case 'SA': return ImgID.Flag_SA;
    case 'SB': return ImgID.Flag_SB;
    case 'SC': return ImgID.Flag_SC;
    case 'SD': return ImgID.Flag_SD;
    case 'SE': return ImgID.Flag_SE;
    case 'SG': return ImgID.Flag_SG;
    case 'SH': return ImgID.Flag_SH;
    case 'SI': return ImgID.Flag_SI;
    case 'SK': return ImgID.Flag_SK;
    case 'SL': return ImgID.Flag_SL;
    case 'SM': return ImgID.Flag_SM;
    case 'SN': return ImgID.Flag_SN;
    case 'SO': return ImgID.Flag_SO;
    case 'SR': return ImgID.Flag_SR;
    case 'SS': return ImgID.Flag_SS;
    case 'ST': return ImgID.Flag_ST;
    case 'SV': return ImgID.Flag_SV;
    case 'SY': return ImgID.Flag_SY;
    case 'SZ': return ImgID.Flag_SZ;
    case 'TC': return ImgID.Flag_TC;
    case 'TD': return ImgID.Flag_TD;
    case 'TF': return ImgID.Flag_TF;
    case 'TG': return ImgID.Flag_TG;
    case 'TH': return ImgID.Flag_TH;
    case 'TJ': return ImgID.Flag_TJ;
    case 'TK': return ImgID.Flag_TK;
    case 'TL': return ImgID.Flag_TL;
    case 'TM': return ImgID.Flag_TM;
    case 'TN': return ImgID.Flag_TN;
    case 'TO': return ImgID.Flag_TO;
    case 'TR': return ImgID.Flag_TR;
    case 'TT': return ImgID.Flag_TT;
    case 'TV': return ImgID.Flag_TV;
    case 'TW': return ImgID.Flag_TW;
    case 'TZ': return ImgID.Flag_TZ;
    case 'UA': return ImgID.Flag_UA;
    case 'UG': return ImgID.Flag_UG;
    case 'US': return ImgID.Flag_US;
    case 'UY': return ImgID.Flag_UY;
    case 'UZ': return ImgID.Flag_UZ;
    case 'VA': return ImgID.Flag_VA;
    case 'VC': return ImgID.Flag_VC;
    case 'VE': return ImgID.Flag_VE;
    case 'VG': return ImgID.Flag_VG;
    case 'VI': return ImgID.Flag_VI;
    case 'VN': return ImgID.Flag_VN;
    case 'VU': return ImgID.Flag_VU;
    case 'WF': return ImgID.Flag_WF;
    case 'WS': return ImgID.Flag_WS;
    case 'YE': return ImgID.Flag_YE;
    case 'YT': return ImgID.Flag_YT;
    case 'ZA': return ImgID.Flag_ZA;
    case 'ZM': return ImgID.Flag_ZM;
    case 'ZW': return ImgID.Flag_ZW;

    // Regional flags (special handling)
    case 'ABKHAZIA': return ImgID.Flag_abkhazia;
    case 'BASQUE_COUNTRY': return ImgID.Flag_basque_country;
    case 'BRITISH_ANTARCTIC_TERRITORY': return ImgID.Flag_british_antarctic_territory;
    case 'COMMONWEALTH': return ImgID.Flag_commonwealth;
    case 'ENGLAND': return ImgID.Flag_england;
    case 'GOSQUARED': return ImgID.Flag_gosquared;
    case 'KOSOVO': return ImgID.Flag_kosovo;
    case 'MARS': return ImgID.Flag_mars;
    case 'NAGORNO_KARABAKH': return ImgID.Flag_nagorno_karabakh;
    case 'NATO': return ImgID.Flag_nato;
    case 'NORTHERN_CYPRUS': return ImgID.Flag_northern_cyprus;
    case 'OLYMPICS': return ImgID.Flag_olympics;
    case 'RED_CROSS': return ImgID.Flag_red_cross;
    case 'SCOTLAND': return ImgID.Flag_scotland;
    case 'SOMALILAND': return ImgID.Flag_somaliland;
    case 'SOUTH_OSSETIA': return ImgID.Flag_south_ossetia;
    case 'UNITED_NATIONS': return ImgID.Flag_united_nations;
    case 'WALES': return ImgID.Flag_wales;

    default:
      return ImgID.Flag_unknown;
  }
}
